export const isVtiVehicle = (dataSource?: string) => {
  return dataSource === 'GWC_D2C';
};
